import { Injectable } from '@angular/core';
import { LanguageWords } from './language.model';
import { BehaviorSubject } from 'rxjs';
import * as LangPtBrJson from './languages/pt-BR.json';
import * as LangEnUsJson from './languages/en-US.json';
import { DataStorageService } from 'src/app/storage/data-storage.service';

@Injectable({
  providedIn: 'root',
})
export class LanguageService {
  words: LanguageWords;

  locale = 'pt_BR';
  languageCode = 'pt-BR';
  languagePrefix = 'pt';

  private langBS = new BehaviorSubject<string>('');
  langObs = this.langBS.asObservable();

  constructor(private storage: DataStorageService) {
    // Sets the language to default first.
    this.setLang('pt-BR');

    // Reads the last language code the app was using and set the current language.
    this.storage.get('app-language').then((langCode) => {
      if (langCode) {
        this.setLang(langCode);
      } else {
        // If the user hasn't set the language yet, we read the preferred language from the browser
        // and set the app language accordingly.
        const userPreferredLangs = window.navigator.languages || [
          window.navigator.language,
        ];

        if (userPreferredLangs[0].includes('en')) {
          this.setLang('en-US');
        } else {
          // Falls back to English
          this.setLang('pt-BR');
        }
      }
    });

    //console.log(window.navigator.languages || [window.navigator.language]);
  }

  /**
   * Sets the current language that the app is using. This will translate all words in the app layout (not on contents like boards or cards)
   * to the selected language.
   *
   * @param langCode ISO Language code (http://www.lingoes.net/en/translator/langcode.htm)
   */
  setLang(langCode: string) {
    let idiom: LanguageWords;
    const defaultLang: LanguageWords = (LangPtBrJson as any).default;

    this.locale = langCode.replace('-', '_');
    this.languageCode = langCode;
    this.languagePrefix = langCode.split('-')[0];

    switch (langCode) {
      case 'en-US':
        idiom = (LangEnUsJson as any).default;
        break;
        default:
        idiom = (LangPtBrJson as any).default;
        break;
    }

    this.words = this.mergeDeep(defaultLang, idiom);
    // Set and save the current language so the next time the app will be presented on that language
    this.langBS.next(langCode);
    this.storage.set('app-language', langCode);
  }

  /**
   * Deep merge two objects.
   *
   * @param target
   * @param ...sources
   */
  mergeDeep(target, ...sources) {
    if (!sources.length) {
      return target;
    }
    const source = sources.shift();

    if (this.isObject(target) && this.isObject(source)) {
      for (const key in source) {
        if (this.isObject(source[key])) {
          if (!target[key]) {
            Object.assign(target, { [key]: {} });
          }
          this.mergeDeep(target[key], source[key]);
        } else {
          Object.assign(target, { [key]: source[key] });
        }
      }
    }
    return this.mergeDeep(target, ...sources);
  }

  /**
   * Simple object check.
   *
   * @param item
   * @returns {boolean}
   */

  isObject(item) {
    return item && typeof item === 'object' && !Array.isArray(item);
  }
}
